<template>

    <div >
        <v-container fluid grid-list-xl class="alerts-info-top-bar">
            <div style="text-align: left;" class="patients-info-top">
                <patient-info></patient-info>
            </div>
            <div style="text-align: right;" class="alerts-top">
                <assessment-alerts></assessment-alerts>
            </div>
        </v-container>


    </div>
</template>

<!-- ################################################################## -->

<script>
    import AssessmentAlerts from "./AssessmentAlerts";
    import PatientInfo from "./PatientInfo";

    export default {
        name: 'TopBar',
        components: {
            AssessmentAlerts,
            PatientInfo
        }
    }
</script>




// WEBPACK FOOTER //
// src/common/components/shared/TopBar.vue